import { SR_API_ACTION_UTILITY_ACTIVATION_GET } from 'api/utilityActionTypes';

export default async function getByUserId(
  { state, utilityApiClient },
  { utilityUserId, forceRefresh = false },
) {
  const statePath = ['utilityActivations', 'byUtilityUserId', utilityUserId];
  if (state.get(statePath) && !forceRefresh) {
    return state.get(statePath);
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_ACTIVATION_GET,
    state: state,
    queryId: utilityUserId,
    payload: {
      utilityUserId,
    },
    onSuccess(utilityActivation) {
      state.set(statePath, utilityActivation);
    },
  });
}
